/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/manage.scss';
import Paging from '../../component/Inc/Paging';
import Modal from '../../component/Inc/Modal';
function Discount() {
  const [modalAlert, setModalAlert] = useState(false);
  return (
    <main className="com_container p_manage_discount">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_8">할인코드 관리</h2>
          <div className="com_btn_wrap">
            <button onClick={() => {}} className="com_btn orange s btn_plus">
              할인코드 추가
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="form_wrap">
              <table className="com_board_list">
                <colgroup>
                  <col width="300" />
                  <col width="400" />
                  <col width="auto" />
                  <col width="200" />
                </colgroup>
                <thead>
                  <tr>
                    <th>할인 코드명 입력</th>
                    <th>설명</th>
                    <th>할인 방법</th>
                    <th>사용</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="td_left">
                      <input type="text" className="input" defaultValue={`형제 할인`} />
                    </td>
                    <td className="td_left">
                      <input type="text" className="input" defaultValue={`형제가 동시 수업진행시 1명에 한하여 할인을 지급한다.`} />
                    </td>
                    <td>
                      <div className="com_radio_wrap">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                          <label htmlFor="rdo01">%</label>
                          <input type="text" className="input ws" defaultValue={`10`} />
                        </div>
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                          <label htmlFor="rdo02">금액</label>
                          <input type="text" className="input ws" defaultValue={`1,000원`} />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="check">
                        <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                        <label htmlFor="rdo2_1">사용</label>
                        <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                        <label htmlFor="rdo2_2">미사용</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              {/*<div className="btn_wrap">
                <button className="btn_link blue">등록</button>
              </div>*/}
              <div className="btn_wrap">
                <button className="com_btn orange">저장</button>
                <button
                  className="com_btn gray"
                  onClick={() => {
                    setModalAlert(true);
                  }}
                >
                  삭제
                </button>
              </div>
            </div>
          </section>
					<section className="box full">
            <div className="form_wrap">
              <table className="com_board_list">
                <colgroup>
                  <col width="300" />
                  <col width="400" />
                  <col width="auto" />
                  <col width="200" />
                </colgroup>
                <thead>
                  <tr>
                    <th>할인 코드명 입력</th>
                    <th>설명</th>
                    <th>할인 방법</th>
                    <th>사용</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="td_left">
                      <input type="text" className="input" defaultValue={`형제 할인`} />
                    </td>
                    <td className="td_left">
                      <input type="text" className="input" defaultValue={`형제가 동시 수업진행시 1명에 한하여 할인을 지급한다.`} />
                    </td>
                    <td>
                      <div className="com_radio_wrap">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                          <label htmlFor="rdo01">%</label>
                          <input type="text" className="input ws" defaultValue={`10`} />
                        </div>
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                          <label htmlFor="rdo02">금액</label>
                          <input type="text" className="input ws" defaultValue={`1,000원`} />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="check">
                        <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                        <label htmlFor="rdo2_1">사용</label>
                        <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                        <label htmlFor="rdo2_2">미사용</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="btn_wrap">
                <button className="btn_link blue">등록</button>
              </div>
            </div>
          </section>
          <section className="box full">
            <table className="com_board_list">
              <colgroup>
                <col width="3%" />
                <col width="8%" />
                <col width="14%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="6%" />
              </colgroup>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>할인 코드명 입력</th>
                  <th>설명</th>
                  <th>할인 (%)</th>
                  <th>할인 금액(원)</th>
                  <th>사용</th>
                  <th>수정</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(9)].map((i, idx) => (
                  <tr key={idx}>
                    <td>2</td>
                    <td>임직원친척</td>
                    <td>사용전 사전승인이 반드시 필요합니다.</td>
                    <td>10</td>
                    <td>-</td>
                    <td>
                      <div className="check">
                        <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                        <label htmlFor="rdo2_1">사용</label>
                        <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                        <label htmlFor="rdo2_2">미사용</label>
                      </div>
                    </td>
                    <td>
                      <button className="btn_link blue">수정</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
      </div>
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt">
            삭제 하시겠습니까?
            <br />
            삭제후에도 이미 지급한 할인코드는 <br />
            사라지지 않습니다.
          </div>
          <div className="btn_container">
            <button onClick={() => setModalAlert(false)} className="com_btn gray xs">
              취소
            </button>
            <button className="com_btn orange xs">이동</button>
          </div>
        </div>
      </Modal>
    </main>
  );
}

export default Discount;
